/**
 * `0x8f2A…0F52` — the standard truncation, and what every rendering of an
 * address in this client uses: the header chip, the account menu, the
 * leaderboard, the session list.
 *
 * **The account menu showed the address in full until §F136**, wrapped over
 * three lines of mono, on the argument that it is where a user checks *which
 * wallet am I signed in as*. It read as noise, and the question is answered
 * better by the Copy button beside the short form — what someone checking a
 * wallet does is paste it — with the full address as that row's tooltip.
 */
export function truncateAddress(address: string): string {
  if (address.length <= 12) return address
  return `${address.slice(0, 6)}…${address.slice(-4)}`
}
